<template>
  <hi-sub-page>
    <hi-page-column card width="375px" fix-width>
      <sms-editor v-model="smsText"></sms-editor>
    </hi-page-column>
    <hi-page-column card width="375px" fix-width>
      <sms-scheduler :sms-text="smsText" ref="scheduler"></sms-scheduler>
      <template v-slot:footer>
        <hi-row flex>
          <v-btn small text @click="dispatch">Dispatch</v-btn>
          <v-spacer />
          <v-btn small text @click="save">Save Campaign</v-btn>
          <v-spacer />
          <v-btn small text @click="send">send</v-btn>
        </hi-row>
      </template>
    </hi-page-column>
    <hi-page-column card grow> test </hi-page-column>
  </hi-sub-page>
</template>

<script>
import HiSubPage from "@/components/scaffold/HiSubPage";
import SmsEditor from "@/components/sms/SmsEditor";
import SmsScheduler from "@/components/sms/SmsScheduler";
import HiPageColumn from "@/components/scaffold/HiPageColumn";
import HiRow from "@/components/scaffold/HiRow";
import { db } from "@/db";
import { api } from "@/api";
export default {
  name: "SMS_Campaign",
  components: { HiRow, SmsEditor, HiSubPage, SmsScheduler, HiPageColumn },
  data() {
    return {
      smsText: null
    };
  },
  methods: {
    async save() {
      const toUpdate = {
        body: this.smsText,
        to: { leads: this.$refs.scheduler.projectsValue }
      };
      console.log(toUpdate);
      await db
        .collection("sms/bulk/campaigns")
        .doc(this.$route.params.campaignId)
        .set(toUpdate, { merge: true });
      console.log("updated");
    },
    async dispatch() {
      console.log(this.$route.params.campaignId);
      await api.sms.dispatchCampaign(this.$route.params.campaignId);
      console.log("dispatched");
    },
    async send() {
      await api.sms.sendCampaign(this.$route.params.campaignId);
      console.log("dispatched");
    }
  },
  created() {
    console.log(this.$route.params.campaignId);
  }
};
</script>

<style scoped></style>
